
















import { Component, Vue } from 'vue-property-decorator'
import TedsLauncherMobileFooter from '../TedsLauncherMobileFooter/TedsLauncherMobileFooter.vue'
import TedsLauncherWelcome from '../TedsLauncherWelcome/TedsLauncherWelcome.vue'

@Component({
  components: {
    TedsLauncherMobileFooter,
    TedsLauncherWelcome,
  },
})
export default class TedsLauncherLayout extends Vue {}
